import * as application from './application';
import * as destinations from './destinations';
import * as channels from './channels';
import * as trackingLink from './trackingLink';
import * as customer from './customer';

export {
  application,
  destinations,
  channels,
  trackingLink,
  customer,
};
